import moment from 'moment';
import { BOOKING, CREW_MEMBER } from '../constants';
// import { sendBookingConversion } from '../helpers/analytics';

export const initialState = {
  currentBooking: undefined,
  loading: false,
  error: undefined,
  survey: undefined
};

const booking = (state = initialState, action) => {
  switch (action.type) {
  case 'UPDATE_BOOKING': {
    // eCommerce conversion tracking:
    if (state.currentBooking && action.booking &&
        state.currentBooking.status === BOOKING.PENDING_STATUS &&
        action.booking.status === BOOKING.OK_STATUS
    ) {
      // sendBookingConversion(action.booking);
    }
    if (action.booking) {
      localStorage.currentBooking = JSON.stringify({
        company: action.booking.week.company.id === 4 ? 'YNF' : 'TYW'
        // here we can add more stuff related to booking so we can access is from GTM
      });
    }
    return {
      ...state,
      currentBooking: action.booking,
      error: undefined,
      loading: false
    };
  }
  case 'SET_BOOKING_LOADING':
    return {
      ...state,
      loading: action.loading
    };
  case 'SET_BOOKING_ERROR':
    return {
      ...state,
      error: { message: action.message },
      loading: false
    };
  case 'ADD_PAYMENT': {
    if (!state.currentBooking) {
      return state;
    }

    let newCrewMembers = state.crewMembers || [];
    const crewMember = newCrewMembers.find(member => member.profile.id === action.payment.profile.id);
    if (crewMember) {
      crewMember.paidAmount += action.payment.amountRegistered;
      newCrewMembers = [
        ...state.crewMembers.filter(member => member.profile.id !== crewMember.profile.id),
        crewMember
      ];
    }

    if (action.payment.order.id === state.currentBooking.mainOrder.id) {
      const newBooking = {
        ...state.currentBooking,
        mainOrder: {
          ...state.currentBooking.mainOrder,
          payments: [
            ...state.currentBooking.mainOrder.payments.filter(p => p.id !== action.payment.id),
            action.payment
          ]
        }
      };
      newBooking.mainOrder.status = action.payment.order.status;
      if (action.payment.status === 'paid' && state.currentBooking.status === BOOKING.PENDING_STATUS) {
        newBooking.status = BOOKING.OK_STATUS;
        // sendBookingConversion(newBooking);
      }
      return {
        ...state,
        currentBooking: newBooking,
        crewMembers: newCrewMembers
      };
    }
    return state;
  }
  case 'SET_EXTRAS_PRODUCTS': {
    return {
      ...state,
      extrasProducts: action.extrasProducts,
      error: undefined
    };
  }
  case 'SET_CREW': {
    return {
      ...state,
      crewMembers: action.data.crewMembers,
      skipper: action.data.skipper,
      hostess: action.data.hostess,
      inviteLink: action.data.inviteLink,
      error: undefined,
      loading: false
    };
  }
  case 'DELETE_MEMBER': {
    const deletedCrewMember = state.crewMembers.find(crew => crew.id === action.memberId);
    const remainingCrewMembers = state.crewMembers.filter(crew => crew.id !== action.memberId);
    deletedCrewMember.status = CREW_MEMBER.DELETED_STATUS;
    return {
      ...state,
      crewMembers: [...remainingCrewMembers, deletedCrewMember]
    };
  }
  case 'ADD_USER': {
    const newCrewMembers = [...state.crewMembers];
    newCrewMembers.push(action.crewMember);
    return {
      ...state,
      crewMembers: newCrewMembers
    };
  }
  case 'DISPLAY_ALERT': {
    return {
      ...state,
      message: alert.message,
      alertType: alert.alertType,
      visible: alert.visible
    };
  }
  case 'INVITE_EMAILS': {
    const newCurrentBooking = { ...state.currentBooking };
    const newCrewInvites = [...(state.currentBooking.crewInvites || [])];

    action.crewInvites.forEach(invitee => newCrewInvites.push(invitee));
    newCurrentBooking.crewInvites = newCrewInvites;
    return {
      ...state,
      currentBooking: newCurrentBooking
    };
  }
  case 'UPDATE_PAYLINKS': {
    const newCurrentBooking = { ...state.currentBooking };
    newCurrentBooking.payLinks = action.payLinks;
    return {
      ...state,
      currentBooking: newCurrentBooking
    };
  }
  case 'UPDATE_PAYLINK': {
    if (!state.currentBooking) {
      return state;
    }
    const newCurrentBooking = { ...state.currentBooking };
    const mapped = {};
    state.currentBooking.payLinks.forEach(link => (mapped[link.id] = { ...link }));
    mapped[action.payLink.id] = action.payLink;
    const payLinks = Object.values(mapped);
    newCurrentBooking.payLinks = payLinks;
    return {
      ...state,
      currentBooking: newCurrentBooking
    };
  }
  /** @deprecated Legacy cost-split reducer; only true for pre-existing bookings. */
  case 'SET_COST_SPLIT': {
    const newCurrentBooking = action.booking;
    return {
      ...state,
      currentBooking: newCurrentBooking
    };
  }
  case 'SET_CREW_FINDER': {
    const newCurrentBooking = action.booking;
    newCurrentBooking.crewFinder = action.crewFinder;

    return {
      ...state,
      currentBooking: newCurrentBooking
    };
  }
  case 'CHANGE_CURRENCY':
    if (!state.currentBooking) {
      return state;
    }
    return {
      ...state,
      currentBooking: { ...state.currentBooking, currency: action.currency }
    };
  case 'UPDATE_BOOKING_ACTIVITY':
    return {
      ...state,
      currentBooking: { ...state.currentBooking, lastActivity: moment().toString() }
    };
  case 'UPDATE_CREW_DATA':
    return {
      ...state,
      currentBooking: { ...state.currentBooking, ...action.crewData }
    };
  case 'SET_SURVEY':
    return {
      ...state,
      survey: action.survey
    };
  case 'SET_BOOKING_UPGRADE':
    return {
      ...state,
      bookingUpgrade: action.bookingUpgrade
    };
  default:
    return state;
  }
};

export default booking;
